var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"unavailable"},[_c('div',{staticClass:"ui icon header"},[_c('i',{staticClass:"huge ban icon"}),_c('div',{staticClass:"content"},[_vm._v("\n\t\t\t"+_vm._s(_vm.i18n('Validation.UnavailableReport'))+"\n\t\t")])])])}
var staticRenderFns = []

export { render, staticRenderFns }